/**
 * Runtime "Beta phase" flag store. Sourced once from the backend's
 * `/public-config` endpoint. Default is `false` so no beta UI flashes before
 * the config has loaded; when the flag is OFF (or the backend is unreachable)
 * every beta surface stays hidden site-wide.
 */
import { writable } from "svelte/store";
import { fetchPublicConfig } from "./api";

export const betaEnabled = writable<boolean>(false);

let initialized = false;

/**
 * Fetch the public config once and update {@link betaEnabled}. Guarded so it
 * only hits the network a single time per page load. Fail-soft: any error
 * leaves the flag at its default (false).
 */
export async function initBeta(): Promise<void> {
  if (initialized) return;
  initialized = true;
  const cfg = await fetchPublicConfig();
  betaEnabled.set(cfg.beta);
}
